/**
 * Endereços assinados das capturas (ADR-G26). A API manda, com o guia e com a lista de guias,
 * os parâmetros «e=…&s=…» de cada captura: com eles, a captura lê-se sem sessão (só o Worker e
 * o R2) e o navegador guarda-a até ao dia seguinte. Sem eles, ou se falharem, usa-se a rota com
 * sessão, como antes.
 */
const access = new Map<string, string>();

const key = (guideId: string, imageId: string) => `${guideId}/${imageId}`;

export function rememberImageAccess(guideId: string, map: Record<string, string> | undefined) {
  if (map) for (const [imageId, q] of Object.entries(map)) access.set(key(guideId, imageId), q);
}

export const imageAccessFor = (guideId: string, imageId: string) =>
  access.get(key(guideId, imageId));

/** Esquece uma assinatura que falhou (expirada, por exemplo): o pedido seguinte leva a sessão. */
export const forgetImageAccess = (guideId: string, imageId: string) =>
  access.delete(key(guideId, imageId));
